import {Link} from 'react-router-dom';
import {useParams} from 'react-router-dom';
import {useState,useEffect} from 'react';
import axios from "axios";
import {baseUrl, userLocation, ipAddress, userName} from '../Univ.js'
function TicketMenu(){
const userGroup= localStorage.getItem('userGroup');
    return (
        <section className="container mt-4">
            <div className="row nurseInpatient">
                <div className='col-md-12 col-12'>
                    <div className="row">
                    <div className="col-md-12 company-info">
                    <div className="panel panel-primary">
                    <div className="panel-heading">
                    <h4 className="panel-title" >Ticketing System</h4>
                    </div>
                    </div>
                    </div>
                    </div>

                    <div className="row">
                    <div className="col-md-12 company-info mb-3">
                    <div className="btn-group">
                    <a href="/ticketing"><button type="button" className="btn btn"><span >Raise Ticket</span></button></a></div>
                    {userGroup === 'Admin' ? (
                    <div className="btn-group">
                    <a href="/ticket-response"><button type="button" className="btn btn"><span >Ticket Reponse</span></button></a></div>
                    ) : null}
                    </div>
                    </div>

               </div>
            </div>
        </section>
    )
}

export default TicketMenu;